import React from 'react';
import { FormattedMessage } from 'react-intl';
import NotFoundState from '@rio-cloud/rio-uikit/NotFoundState';
import { Campaign } from '~/api/models/campaign';

interface CampaignUpdateEventsProps {
  campaign?: Campaign;
}

const CampaignUpdateEvents: React.FC<CampaignUpdateEventsProps> = ({ campaign }) => {
  return (
      <div className='border-color-lighter padding-20 border-radius-5 border-width-1 border-style-solid height-100pct'>
      <h4 className='margin-top-0 margin-bottom-15'>Updates</h4>
      <NotFoundState
        fullWidth
        outerClassName={'border-none'}
        headline={<FormattedMessage id='No update events yet'/>}
      />
    </div>
  );
};

export default CampaignUpdateEvents;
